
         <div class="hero-header">
          <app-header-latest></app-header-latest>
      </div>
      <!-- HERO -->
<div class="contact-hero"  style="background-image:url('assets/images/banner/custom-contact-us.jpg');    background-repeat: no-repeat;background-size: cover;padding-bottom: 40px; height: 100vh;">
  <div class="container-wrapper " style="position:relative;z-index:2;">
    <div class="section-eyebrow">💬 GET IN TOUCH</div>
    <h1>We'd Love to<br>Hear from You</h1>
    <p>Whether you're ready to start a trial, have a question about our product, or just want to say hello — our team typically responds within 2 hours.</p>
    <div class="contact-channels">
      <div class="contact-channel-badge">💬 Live Chat — Available Now</div>
      <div class="contact-channel-badge">📧 Email — 2hr response</div>
      <div class="contact-channel-badge">📞 Phone — Mon–Fri 9–6</div>
    </div>
  </div>
</div>

<!-- CHANNEL CARDS -->
<section class="channels-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">📡 How to Reach Us</span>
      <h2 class="sec-h2">Choose Your<br><span class="gradient-text">Preferred Channel</span></h2>
      <p class="sec-sub">Every channel connects you to a real person — no bots, no ticket queues, no outsourced support.</p>
    </div>
    <div class="channels-grid">
      <div class="channel-card">
        <div class="channel-card__icon">💬</div>
        <div class="channel-card__title">Live Chat</div>
        <div class="channel-card__desc">Talk to our product team in real time via the in-app chat widget or the button below. Fastest for quick questions.</div>
        <div class="channel-card__detail">Avg. response: &lt; 3 minutes</div>
      </div>
      <div class="channel-card">
        <div class="channel-card__icon">📧</div>
        <div class="channel-card__title">Email</div>
        <div class="channel-card__desc">Send us a detailed message and a specialist will get back to you with a thorough, thoughtful answer.</div>
        <div class="channel-card__detail">hello@NeoHRMZ.io</div>
      </div>
      <div class="channel-card">
        <div class="channel-card__icon">📅</div>
        <div class="channel-card__title">Book a Demo</div>
        <div class="channel-card__desc">Schedule a 30-minute walkthrough with a product specialist tailored to your team size and use case.</div>
        <div class="channel-card__detail">Next slot: Tomorrow 10am IST</div>
      </div>
    </div>
  </div>
</section>

<!-- CONTACT FORM -->
<section class="contact-form-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">📝 Send a Message</span>
      <h2 class="sec-h2">Drop Us a Line</h2>
      <p class="sec-sub">Fill in the form below and the right team member will follow up within one business day.</p>
    </div>
    <div class="contact-layout">
      <div class="contact-form-card">
        <div class="form-row">
          <div class="form-field">
            <label class="form-label">First Name</label>
            <input type="text" class="form-input" placeholder="Priya" />
          </div>
          <div class="form-field">
            <label class="form-label">Last Name</label>
            <input type="text" class="form-input" placeholder="Sharma" />
          </div>
        </div>
        <div class="form-field">
          <label class="form-label">Work Email</label>
          <input type="email" class="form-input" placeholder="priya@company.com" />
        </div>
        <div class="form-row">
          <div class="form-field">
            <label class="form-label">Company</label>
            <input type="text" class="form-input" placeholder="Acme Corp" />
          </div>
          <div class="form-field">
            <label class="form-label">Team Size</label>
            <select class="form-select">
              <option>1–25 employees</option>
              <option>26–100 employees</option>
              <option>101–500 employees</option>
              <option>500+ employees</option>
            </select>
          </div>
        </div>
        <div class="form-field">
          <label class="form-label">What can we help you with?</label>
          <select class="form-select">
            <option>Product Demo Request</option>
            <option>Pricing / Billing Query</option>
            <option>Technical Support</option>
            <option>Partnership Inquiry</option>
            <option>Press / Media</option>
            <option>Other</option>
          </select>
        </div>
        <div class="form-field">
          <label class="form-label">Message</label>
          <textarea class="form-textarea" placeholder="Tell us a bit about your team and what you're looking for…"></textarea>
        </div>
        <a href="#" class="btn btn-primary" style="width:100%;justify-content:center;">Send Message</a>
      </div>
      <div class="contact-sidebar">
        <div class="contact-info-card">
          <div class="contact-info-card__title">Direct Contact</div>
          <div class="contact-info-list">
            <div class="contact-info-item">
              <div class="contact-info-item__icon">📧</div>
              <div><div class="contact-info-item__label">General</div><div class="contact-info-item__text">hello@NeoHRMZ.io</div></div>
            </div>
            <div class="contact-info-item">
              <div class="contact-info-item__icon">🛡️</div>
              <div><div class="contact-info-item__label">Security</div><div class="contact-info-item__text">security@NeoHRMZ.io</div></div>
            </div>
            <div class="contact-info-item">
              <div class="contact-info-item__icon">📰</div>
              <div><div class="contact-info-item__label">Press</div><div class="contact-info-item__text">press@NeoHRMZ.io</div></div>
            </div>
            <div class="contact-info-item">
              <div class="contact-info-item__icon">🤝</div>
              <div><div class="contact-info-item__label">Partnerships</div><div class="contact-info-item__text">partners@NeoHRMZ.io</div></div>
            </div>
          </div>
        </div>
        <div class="contact-info-card">
          <div class="contact-info-card__title">Support Hours</div>
          <div class="contact-info-list">
            <div class="contact-info-item">
              <div class="contact-info-item__icon">🕐</div>
              <div><div class="contact-info-item__label">Chat &amp; Email</div><div class="contact-info-item__text">Mon–Fri, 9am–9pm IST</div></div>
            </div>
            <div class="contact-info-item">
              <div class="contact-info-item__icon">🚨</div>
              <div><div class="contact-info-item__label">Critical Incidents</div><div class="contact-info-item__text">24/7 for Enterprise plans</div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- OFFICE LOCATIONS -->
<section class="offices-section">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">🏢 Our Offices</span>
      <h2 class="sec-h2">Find Us Around<br><span class="gradient-text">the World</span></h2>
      <p class="sec-sub">We're a remote-first company with physical hubs in four cities for those who prefer to work in person.</p>
    </div>
    <div class="offices-grid">
      <div class="office-card">
        <div class="office-card__flag">🇮🇳</div>
        <div class="office-card__city">Bangalore</div>
        <div class="office-card__addr">HQ — 12th Floor, Embassy Tech Village, Outer Ring Road</div>
        <div class="office-card__type">Headquarters</div>
      </div>
      <div class="office-card">
        <div class="office-card__flag">🇺🇸</div>
        <div class="office-card__city">San Francisco</div>
        <div class="office-card__addr">548 Market St, Suite 92, San Francisco, CA 94104</div>
        <div class="office-card__type">US Hub</div>
      </div>
      <div class="office-card">
        <div class="office-card__flag">🇬🇧</div>
        <div class="office-card__city">London</div>
        <div class="office-card__addr">1 Canada Square, Canary Wharf, London E14 5AB</div>
        <div class="office-card__type">EMEA Hub</div>
      </div>
      <div class="office-card">
        <div class="office-card__flag">🇸🇬</div>
        <div class="office-card__city">Singapore</div>
        <div class="office-card__addr">One Raffles Quay, North Tower, Level 35</div>
        <div class="office-card__type">APAC Hub</div>
      </div>
    </div>
  </div>
</section>

<!-- FAQ -->
<section class="contact-faq">
  <div class="container-wrapper">
    <div class="sec-head">
      <span class="section-eyebrow">❓ Common Questions</span>
      <h2 class="sec-h2">Before You Reach Out</h2>
      <p class="sec-sub">Quick answers to the questions we hear most often from new customers and prospects.</p>
    </div>
    <div class="faq-list">
      <div class="faq-item">
        <div class="faq-item__q">What is NeoHRMZ?</div>
        <div class="faq-item__a">NeoHRMZ is a comprehensive Human Resources Management System designed and developed for all types of business entities or enterprises, both small and big. It spans the entire employee lifecycle, from recruitment to exit, and contains different user roles (Employees, Managers, HR, Payroll, Finance, Recruiters, Administrators, Vendors, Executives, etc.).</div>
      </div>
      <div class="faq-item">
        <div class="faq-item__q">Who can register for the NeoHRMZ application?</div>
        <div class="faq-item__a">Any agency, firm, company, or organization having more than 20 employees can register on NeoHRMZ. In many organizations, employee accounts are created automatically by HR during onboarding.</div>
      </div>
      <div class="faq-item">
        <div class="faq-item__q">How do I login to the NeoHRMZ application?</div>
        <div class="faq-item__a">To login, you need to enter your registered Employee ID, Email ID, or Username and your password. If Multi-Factor Authentication (MFA) is enabled, enter the OTP sent to your registered email or mobile device.</div>
      </div>
      <div class="faq-item">
        <div class="faq-item__q">I forgot my password. How can I reset it?</div>
        <div class="faq-item__a">Click the Forgot Password link on the login page. Enter your registered Email ID or Username. Verify your identity using the OTP or email verification link. Create a new password that meets the organization's password policy. Log in using the newly created password.</div>
      </div>
      <div class="faq-item">
        <div class="faq-item__q">Why is my account locked?</div>
        <div class="faq-item__a">Your account may be locked due to multiple incorrect password attempts, security policy enforcement, administrative lock by HR or the System Administrator, or an inactive account after prolonged inactivity. Contact your System Administrator or HR if the account remains locked after the lockout period.</div>
      </div>
      <div class="faq-item">
        <div class="faq-item__q">What is Employee Self Service (ESS)?</div>
        <div class="faq-item__a">Employee Self Service (ESS) is a feature within the NeoHRMZ application that allows employees to manage their own information, update personal details, request time off, view pay stubs, and perform other self-service tasks without needing to contact HR directly.</div>
      </div>
    </div>
  </div>
</section>
<app-peopleflow-footer></app-peopleflow-footer>
